import { IconProps } from "./IconProps";

const OverviewIcon: React.FC<IconProps> = ({
  width = 30,
  height = 30,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none">
      <path
        d="M21.675 22.375L22.375 21.675L20.5 19.8V17H19.5V20.2L21.675 22.375ZM20 25C18.6167 25 17.4375 24.5125 16.4625 23.5375C15.4875 22.5625 15 21.3833 15 20C15 18.6167 15.4875 17.4375 16.4625 16.4625C17.4375 15.4875 18.6167 15 20 15C21.3833 15 22.5625 15.4875 23.5375 16.4625C24.5125 17.4375 25 18.6167 25 20C25 21.3833 24.5125 22.5625 23.5375 23.5375C22.5625 24.5125 21.3833 25 20 25ZM9 11H19V9H9V11ZM13.675 23H7C6.45 23 5.97917 22.8042 5.5875 22.4125C5.19583 22.0208 5 21.55 5 21V7C5 6.45 5.19583 5.97917 5.5875 5.5875C5.97917 5.19583 6.45 5 7 5H21C21.55 5 22.0208 5.19583 22.4125 5.5875C22.8042 5.97917 23 6.45 23 7V13.7C22.5167 13.4667 22.0292 13.2917 21.5375 13.175C21.0458 13.0583 20.5333 13 20 13C19.8167 13 19.6458 13.0042 19.4875 13.0125C19.3292 13.0208 19.1667 13.0417 19 13.075V13H9V15H15.125C14.825 15.2833 14.5542 15.5917 14.3125 15.925C14.0708 16.2583 13.8583 16.6167 13.675 17H9V19H13.075C13.0417 19.1667 13.0208 19.3292 13.0125 19.4875C13.0042 19.6458 13 19.8167 13 20C13 20.55 13.05 21.0625 13.15 21.5375C13.25 22.0125 13.425 22.5 13.675 23Z"
        fill={color}
      />
    </svg>
  );
};
export default OverviewIcon;
